import { put, takeLatest, all, call, takeEvery } from "redux-saga/effects";
import { toast } from "react-hot-toast";
import { setReviewModerationsLoader, setReviews, setReviewsDump, setUpdatedReview } from "../actionCreators/rmActionCreator";
import { downloadReviews, generatePresignedUrlService, getReviewsService, reviewReplyService, updateReviewService, uploadReviewsFileService } from "../services/reviewsService";
import { GENERATE_PRESIGNED_URL, GET_REVIEWS, GET_REVIEWS_DUMP, UPDATE_REVIEW, UPLOAD_REVIEWS_FILE } from "../actionTypes/reviewsModerationActionTypes";

function* _getReviews(_data: any) {
    try {
        yield put(setReviewModerationsLoader(true));
        const { data } = yield call(getReviewsService, _data.payload);
        yield put(setReviewModerationsLoader(false));
        if (data.status == true) {
            yield put(setReviews({
                totalCount: data?.data?.totalCount,
                data: data?.data?.reviewsList
            }))
            _data.callback && _data.callback(data.data)
        }
        return
    }
    catch (err: any) {
        yield put(setReviewModerationsLoader(false));
        toast.error("Something went wrong.")
    }
}

function* _updateReview(_data: any) {
    try {
        yield put(setReviewModerationsLoader(true));
        // if (_data.payload.merchandiseReplyText) {
        //     yield call(reviewReplyService, {
        //         "reply_text": _data.payload.merchandiseReplyText,
        //         "review_id": _data.payload.reviewId
        //     })
        // }
        const { data } = yield call(updateReviewService, _data.payload);
        yield put(setReviewModerationsLoader(false));
        if (data.status == true) {
            _data.callback && _data.callback(data.data)
        }
        return
    }
    catch (err: any) {
        yield put(setReviewModerationsLoader(false));
        toast.error("Something went wrong.")
    }
}

function* _getReviewsDump(_data: any) {
    try {
        yield put(setReviewModerationsLoader(true));
        const { data } = yield call(downloadReviews, _data.payload);
        yield put(setReviewModerationsLoader(false));
        if (data.status == true) {
            yield put(setReviewsDump(data.data))
            _data.callback && _data.callback(data.data)
        }
    }
    catch (err: any) {
        yield put(setReviewModerationsLoader(false));
        toast.error("Something went wrong.")
    }
}

function* _uploadReviewsFile(_data: any) {
    try {
        yield put(setReviewModerationsLoader(true));
        const { data } = yield call(uploadReviewsFileService, _data.payload);
        yield put(setReviewModerationsLoader(false));
        if (data.status == true) {
            yield put(setReviews(data.data))
            _data.callback && _data.callback(data)
        }
        else {
            toast.error(data.data.errorMsg)
        }
    }
    catch (err: any) {
        yield put(setReviewModerationsLoader(false));
        console.log("_uploadReviewsFile: exceptionError: ", err)
        toast.error("Something went wrong.")
    }
}

function* _generatePresignedUrl(_data: any) {
    try {
        const { fileType, fileName, contentType, contentLength, file } = _data.payload;

        // Step 1: Get presigned URL from CMS API
        const { data } = yield call(generatePresignedUrlService, { fileType, fileName, contentType, contentLength });

        if (!data.status || !data.data?.uploadUrl) {
            _data.callback && _data.callback(new Error(data.message || 'Failed to generate presigned URL'), null);
            return;
        }

        const { uploadUrl, fileUrl, key, method } = data.data;

        yield call(() =>
            fetch(uploadUrl, {
                method: method || 'PUT',
                body: file,
                headers: {
                    'Content-Type': contentType
                }
            }).then((res) => {
                if (!res.ok) throw new Error(`S3 upload failed: ${res.status} ${res.statusText}`);
                return res;
            })
        );

        // Step 3: Return the CDN fileUrl to the component
        _data.callback && _data.callback(null, { fileUrl, key });
    }
    catch (err: any) {
        _data.callback && _data.callback(err, null);
    }
}

export default function* rmSaga() {
    yield all([
        takeLatest(GET_REVIEWS, _getReviews),
        takeLatest(UPDATE_REVIEW, _updateReview),
        takeLatest(GET_REVIEWS_DUMP, _getReviewsDump),
        takeLatest(UPLOAD_REVIEWS_FILE, _uploadReviewsFile),
        takeEvery(GENERATE_PRESIGNED_URL, _generatePresignedUrl)
    ])
}